module.exports = __webpack_public_path__ + "img/floor2.2f7eef49.jpg";